import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  UserOutlined,
  ProjectOutlined,
  QuestionCircleOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import logo from "../../images/cronos-logo.svg";
import { rootPath, projectsPath, profilePath, docsPath, dashboardPath } from "../../helpers/paths";
import { getSelected } from "../../helpers/selected";
import { SignOut } from "../signout/SignOut";

export function MainContainer() {
  const location = useLocation();

  const items = [
    {
      label: <Link to={dashboardPath()}>Dashboard</Link>,
      key: "dashboard",
      icon: <HomeOutlined />,
    },
    {
      label: <Link to={projectsPath()}>Projects</Link>,
      key: "projects",
      icon: <ProjectOutlined />,
    },
    {
      label: "Profile",
      key: "profile",
      icon: <UserOutlined />,
      children: [
        {
          label: <Link to={profilePath()}>Account</Link>,
          key: "account",
        },
        {
          label: (
            <SignOut>
              <span>Sign Out</span>
            </SignOut>
          ),
          key: "signout",
        },
      ],
    },
    {
      label: <Link to={docsPath()}>Docs</Link>,
      key: "docs",
      icon: <QuestionCircleOutlined />,
    },
  ];

  const selectedKey = getSelected(
    [
      { key: "dashboard", exactValue: "/" },
      { key: "dashboard", matcher: /^\/dashboard/ },
      { key: "projects", matcher: /^\/projects/ },
      { key: "profile", matcher: /^\/profile/ },
      { key: "docs", matcher: /^\/docs/ },
    ],
    location.pathname,
    "",
  );
  const openKey = getSelected([{ key: "profile", matcher: /^\/profile/ }], location.pathname, "");

  return (
    <Layout id="main" style={{ minHeight: "100vh" }}>
      <Layout.Sider breakpoint="lg" collapsedWidth="0" width="240">
        <Link to={rootPath()} className="sider-logo">
          <img src={logo} alt="cronos" />
        </Link>
        <Menu
          items={items}
          theme="dark"
          mode="inline"
          defaultSelectedKeys={selectedKey !== "" ? [selectedKey] : []}
          defaultOpenKeys={openKey !== "" ? [openKey] : []}
        />
      </Layout.Sider>
      <Layout id="main-content-wrapper">
        <Layout.Content id="main-content">
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  );
}
